<template>
    <FormCard>
        <template #cardTitle>
            Search Hospital/Clinic and Doctor for Appointment
        </template>
        <template #cardSubtitle>
            Please fill out the necessary information about the healthcare provider. The dropdown fields will only show providers THAT YOU HAVE AN ACCESS. If you cannot find the one that you are looking for, please contact HMI.
        </template>
        <template #cardText>
            <v-alert
                color="teal darken-4"
                outlined
                style="margin: 5px 0 0 0"
                type="info"
            >
                <span><strong>Disclaimer: </strong>The accreditation status of each facility and doctor may change before updates are reflected in this list.</span>
            </v-alert>
            <v-card style="padding: 10px 20px; margin-top: 5px" class="elevation-10">
                <ToFilterHosp
                    :to="to"
                    :member_model="member_model"
                    :loading="loading"
                />
                <v-expand-transition>
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`paddingRight: ${screen_width >= 600 ? '5px' : 0}`"
                        >
                            <ToRegion
                                :to="to"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`padding: ${screen_width >= 600 ? '0 5px' : 0}`"
                        >
                            <ToProvince
                                :to="to"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`paddingLeft: ${screen_width >= 600 ? '5px' : 0}`"
                        >
                            <ToCities
                                :to="to"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                    </v-row>
                </v-expand-transition>
                <ToFacilities
                    :to="to"
                    :member_model="member_model"
                    :loading="loading"
                />
            </v-card>
            <v-card
                :ripple="false"
                style="padding: 10px 20px; margin-top: 5px"
                class="elevation-10"
                @click="enableHintOnToDoc()"
            >
                <v-expand-transition>
                    <div v-show="to.hint.doc">
                        <v-alert
                            dense
                            text
                            outlined
                            style="margin: 5px"
                            color="#125C99"
                            type="info"
                        >
                            Please select a hospital before choosing a doctor
                        </v-alert>
                    </div>
                </v-expand-transition>
                <ToFilterDoc
                    :to="to"
                    :disable-elements="disableElements"
                    :loading="loading"
                />
                <ToSpecField :to="to" />
                <div v-if="to.hospClinType === 'C' || String(to.decking).toUpperCase() === 'D' || String(to.decking).toUpperCase() === 'U'">
                    <div v-if="!disableElements && (typeof to.facility == 'object')">
                        <b><i>For this provider, you may leave the doctor's name blank if they are not on the list.</i></b>
                    </div>
                </div>
                <div v-else>
                    <div v-if="!disableElements && (typeof to.facility == 'object')">
                        <b><i>For this provider, you may only select a doctor that is on the list.</i></b>
                    </div>
                </div>
                <div v-if="to.hospClinType === 'C' || String(to.decking).toUpperCase() === 'D' || String(to.decking).toUpperCase() === 'U'">
                    <ToHospClinDoctor
                        :to="to"
                        :disable-elements="disableElements"
                        :loading="loading"
                    />
                </div>
                <div v-else>
                    <ToHospClinDoctor2
                        :to="to"
                        :disable-elements="disableElements"
                        :loading="loading"
                    />
                </div>
            </v-card>
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'
import ToFilterDoc from './Input/To/FilterDoc.vue'
import ToFilterHosp from './Input/To/FilterHosp.vue'
import ToRegion from './Input/To/Region.vue'
import ToProvince from './Input/To/Province.vue'
import ToCities from './Input/To/Cities.vue'
import ToFacilities from './Input/To/Facilities.vue'
import ToSpecField from './Input/To/SpecField.vue'
import ToHospClinDoctor from './Input/To/HospClinDoctor.vue'
import ToHospClinDoctor2 from './Input/To/HospClinDoctor2.vue'
export default {
    components: {
        FormCard,
        ToFilterHosp,
        ToFacilities,
        ToFilterDoc,
        ToRegion,
        ToProvince,
        ToCities,
        ToSpecField,
        ToHospClinDoctor,
        ToHospClinDoctor2
    },
    props: ['to', 'member_model', 'screen_width', 'loading'],
    computed: {
        disableElements() {
            return this.to.facility === '' || this.to.facility === null || this.to.facility && this.to.facility.hosp_msu_code && this.to.facility.hosp_msu_code === ''
        }
    },
    watch: {
        'to.hint.doc'(newVal) {
            if (newVal) {
                setTimeout(()=>{
                    this.to.hint.doc = false
                }, 4000)
            }
        }
    },
    methods: {
        enableHintOnToDoc() {
            this.to.hint.doc = this.disableElements
        }
    }
}
</script>
